module.exports = __webpack_public_path__ + "producr-dried fresh-grass-12.jpg?4906126e9d0f55e64d551ffae645b4d1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-12.jpg
// module id = 70
// module chunks = 0